import { useState } from "react";

const STORAGE_KEY = "walkin:nav_menu_open";

function loadStoredOpen(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function useNavMenu() {
  const [open, setOpen] = useState(loadStoredOpen);

  function toggle() {
    const next = !open;
    setOpen(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // ignore storage access errors (e.g. private browsing)
    }
  }

  return { open, toggle };
}

export function NavMenuToggle({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  return (
    <button
      className="nav-menu-toggle"
      aria-label={open ? "Close menu" : "Open menu"}
      onClick={onToggle}
    >
      ☰
    </button>
  );
}

interface PanelProps {
  open: boolean;
  onInviteClick: () => void;
}

export function NavMenuPanel({ open, onInviteClick }: PanelProps) {
  if (!open) return null;

  return (
    <div className="nav-menu-panel">
      <div className="nav-menu-title">Settings</div>
      <hr className="modal-divider" />
      <span className="nav-menu-item" onClick={onInviteClick}>
        Invite a patient
      </span>
    </div>
  );
}
